// This file was automatically generated from Excel data
// src/components/AttackDatabase.js

// Helper function for creating unique card keys
function createUniqueCardKey(card) {
  // Combine name and set for a unique identifier
  // For backward compatibility, return the ID if it's already globally unique
  if (card.id && card.id.includes('-')) {
    return card.id;
  }
  
  // If already has a uniqueId, use it
  if (card.uniqueId) {
    return card.uniqueId;
  }
  
  // Otherwise create a composite key using name and set
  return `${card.name}__${card.set || 'unknown'}`;
}

// Pre-populated attack database
export const attackDatabase = [
  {
    "id": "87/232",
    "name": "Allmageddon",
    "set": "dop",
    "rarity": "super rare",
    "bp": 5,
    "base": 10,
    "fire": 10,
    "air": 10,
    "earth": 10,
    "water": 10,
    "ability": "",
    "flavorText": "This is the end of all fighting, for you!",
    "unique": true,
    "artist": "Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/7A3qZHW.png",
    "uniqueId": "Allmageddon__dop"
  },
  {
    "id": "88/232",
    "name": "Ash Torrent",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "Challenge :power:Power 15: Deal 10 damage. (Compare the Discipline of the Creature that played this Attack with the opposing engaged Creature. If yours has that amount or more higher, deal the damage.)",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/KEJLzAh.png",
    "uniqueId": "Ash Torrent__dop"
  },
  {
    "id": "89/232",
    "name": "Coil Crush",
    "set": "dop",
    "rarity": "super rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 75: Choose a Battlegear equipped to an opposing Creature and destroy it.",
    "flavorText": "",
    "unique": false,
    "artist": "David Rodriguez, Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/lkXhAbT.png",
    "uniqueId": "Coil Crush__dop"
  },
  {
    "id": "90/232",
    "name": "Degenervate",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 0,
    "ability": ":water:Water: Opposing Creature loses 25 to all Disciplines. Your engaged Creature loses :water:Water.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/aEayVEx.png",
    "uniqueId": "Degenervate__dop"
  },
  {
    "id": "91/232",
    "name": "Delerium",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 50: Deal 5 damage.",
    "flavorText": "Have something for your lack of inspiration!",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/9T8MgYP.png",
    "uniqueId": "Delerium__dop"
  },
  {
    "id": "92/232",
    "name": "Ektospasm",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 50: Deal 5 damage.",
    "flavorText": "This will fit you good!",
    "unique": false,
    "artist": "Keith Conroy, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/5YY7hLr.png",
    "uniqueId": "Ektospasm__dop"
  },
  {
    "id": "93/232",
    "name": "Ember Swarm",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": ":fire:Fire: Opposing engaged Creature loses 25 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/K88z2wG.png",
    "uniqueId": "Ember Swarm__dop"
  },
  {
    "id": "94/232",
    "name": "Evaporize",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15: Heal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel ",
    "imageUrl": "https://i.imgur.com/4ZSP8CC.png",
    "uniqueId": "Evaporize__dop"
  },
  {
    "id": "95/232",
    "name": "Fearocity",
    "set": "dop",
    "rarity": "super rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 75: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel ",
    "imageUrl": "https://i.imgur.com/8u5Rjuv.png",
    "uniqueId": "Fearocity__dop"
  },
  {
    "id": "96/232",
    "name": "Flame Orb",
    "set": "dop",
    "rarity": "super rare",
    "bp": 2,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 75: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, David Curiel",
    "imageUrl": "https://i.imgur.com/J3GlFeF.png",
    "uniqueId": "Flame Orb__dop"
  },
  {
    "id": "97/232",
    "name": "Flash Kick",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Look at the top two cards of your Location Deck. Put one of them on top of that deck and the other on the bottom.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/ClJCrUU.png",
    "uniqueId": "Flash Kick__dop"
  },
  {
    "id": "98/232",
    "name": "Flash Mend",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 50: Heal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Rudy Nebres, Axer",
    "imageUrl": "https://i.imgur.com/bZd9PNz.png",
    "uniqueId": "Flash Mend__dop"
  },
  {
    "id": "99/232",
    "name": "Flashwarp",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :power:Power 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/W83XHNz.png",
    "uniqueId": "Flashwarp__dop"
  },
  {
    "id": "100/232",
    "name": "Frost Blight",
    "set": "dop",
    "rarity": "super rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Check :speed:Speed 75: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Jimmy Tran, Adrian Barrios",
    "imageUrl": "https://i.imgur.com/qJHo8qj.png",
    "uniqueId": "Frost Blight__dop"
  },
  {
    "id": "101/232",
    "name": "Hail Storm",
    "set": "dop",
    "rarity": "super rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": 5,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/UuAvBXS.png",
    "uniqueId": "Hail Storm__dop"
  },
  {
    "id": "102/232",
    "name": "Hive Call",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "You can remove :danianmugic:from a Creature you control. If you do, activate Hive.",
    "flavorText": "",
    "unique": false,
    "artist": "David Curiel, Francis Barrios",
    "imageUrl": "https://i.imgur.com/tgFjtPq.png",
    "uniqueId": "Hive Call__dop"
  },
  {
    "id": "103/232",
    "name": "Incinerase",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": null,
    "ability": ":fire:Fire: Your engaged Creature loses :fire:Fire.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/aKTcXzI.png",
    "uniqueId": "Incinerase__dop"
  },
  {
    "id": "104/232",
    "name": "Inferno Gust",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Challenge :speed:Speed 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Adrian Barrios, David Curiel ",
    "imageUrl": "https://i.imgur.com/9lvMsFm.png",
    "uniqueId": "Inferno Gust__dop"
  },
  {
    "id": "105/232",
    "name": "Iron Balls",
    "set": "dop",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Tribal Mugic cannot be played.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/8os5kcP.png",
    "uniqueId": "Iron Balls__dop"
  },
  {
    "id": "106/232",
    "name": "Lavalanche",
    "set": "dop",
    "rarity": "super rare",
    "bp": 3,
    "base": 10,
    "fire": 5,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, Axer",
    "imageUrl": "https://i.imgur.com/4O7GTaD.png",
    "uniqueId": "Lavalanche__dop"
  },
  {
    "id": "107/232",
    "name": "Lightning Burst",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Opposing engaged Creature loses 25 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "David Rodriguez, Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/UVIb8xy.png",
    "uniqueId": "Lightning Burst__dop"
  },
  {
    "id": "108/232",
    "name": "Lucky Shot",
    "set": "dop",
    "rarity": "ultra rare",
    "bp": 4,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has lower:courage:Courage, :power:Power, :wisdom:Wisdom, :speed:Speed and Current Energy than the opposing engaged Creature, deal 40 damage.",
    "flavorText": "They say fortune favors the brave.",
    "unique": true,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel ",
    "imageUrl": "https://i.imgur.com/GeANzet.png",
    "uniqueId": "Lucky Shot__dop"
  },
  {
    "id": "109/232",
    "name": "Megaroar",
    "set": "dop",
    "rarity": "ultra rare",
    "bp": 4,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 70: Deal 10 damage.\r\nStat Check :power:Power 70: Deal 10 damage.\r\nStat Check :wisdom:Wisdom 70: Deal 10 damage.\r\nStat Check :speed:Speed 70: Deal 10 damage.",
    "flavorText": "",
    "unique": true,
    "artist": "David Rodriguez, Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/NwvsCVk.png",
    "uniqueId": "Megaroar__dop"
  },
  {
    "id": "110/232",
    "name": "Mirthquake",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 0,
    "water": null,
    "ability": ":earth:Earth: Reveal a new active Location. Your engaged Creature loses :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/4JOggvh.png",
    "uniqueId": "Mirthquake__dop"
  },
  {
    "id": "111/232",
    "name": "Paral-Eyes",
    "set": "dop",
    "rarity": "rare",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :speed:Speed 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Jason Narvaez, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/u3ptGz5.png",
    "uniqueId": "Paral-Eyes__dop"
  },
  {
    "id": "112/232",
    "name": "Pebblestorm",
    "set": "dop",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/kGMnaQp.png",
    "uniqueId": "Pebblestorm__dop"
  },
  {
    "id": "113/232",
    "name": "Power Pulse",
    "set": "dop",
    "rarity": "rare",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :power:Power 15: Deal 10 damage.",
    "flavorText": "Check my pulse!",
    "unique": false,
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/CZXBitS.png",
    "uniqueId": "Power Pulse__dop"
  },
  {
    "id": "114/232",
    "name": "Quick Exit",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :wisdom:Wisdom 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/JyfBFyt.png",
    "uniqueId": "Quick Exit__dop"
  },
  {
    "id": "115/232",
    "name": "Rip Tide",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": ":water:Water: Opposing engaged Creature loses 25 :courage:Courage.",
    "flavorText": "Watch out for the undertow!",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/Pn1nLqc.png",
    "uniqueId": "Rip Tide__dop"
  },
  {
    "id": "116/232",
    "name": "Rock Wave",
    "set": "dop",
    "rarity": "super rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 75: Deal 10 damage.",
    "flavorText": "Time to smash ashore.",
    "unique": false,
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/v6JMS8h.png",
    "uniqueId": "Rock Wave__dop"
  },
  {
    "id": "117/232",
    "name": "Rustoxic",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": "Challenge :courage:Courage 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/J78E9yG.png",
    "uniqueId": "Rustoxic__dop"
  },
  {
    "id": "118/232",
    "name": "Shadow Strike",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15: Deal 10 damage.",
    "flavorText": "Afraid of the dark?",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/ne6P49n.png",
    "uniqueId": "Shadow Strike__dop"
  },
  {
    "id": "119/232",
    "name": "Shriek Shock",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 50: Deal 5 damage.",
    "flavorText": "This will be my winning striek!",
    "unique": false,
    "artist": "David Rodriguez, Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/AgvArbl.png",
    "uniqueId": "Shriek Shock__dop"
  },
  {
    "id": "120/232",
    "name": "Skeletal Strike",
    "set": "dop",
    "rarity": "rare",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "David Rodriguez, Edwin Nebres, Teodoro Gonzalez",
    "imageUrl": "https://i.imgur.com/gpopz9l.png",
    "uniqueId": "Skeletal Strike__dop"
  },
  {
    "id": "121/232",
    "name": "Sleep Sting",
    "set": "dop",
    "rarity": "rare",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :wisdom:Wisdom 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Adrian Barrios, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/zpj7oDy.png",
    "uniqueId": "Sleep Sting__dop"
  },
  {
    "id": "122/232",
    "name": "Sludge Gush",
    "set": "dop",
    "rarity": "super rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/KHrLEmZ.png",
    "uniqueId": "Sludge Gush__dop"
  },
  {
    "id": "123/232",
    "name": "Spirit Gust",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 50: Deal 5 damage.",
    "flavorText": "This will blow you away.",
    "unique": false,
    "artist": "Andrew Bradshaw, Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/raxuq4P.png",
    "uniqueId": "Spirit Gust__dop"
  },
  {
    "id": "124/232",
    "name": "Squeeze Play",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Look at the top two cards of your Attack Deck. Put one of them on top of that deck and the other on the bottom.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/TqkpQPd.png",
    "uniqueId": "Squeeze Play__dop"
  },
  {
    "id": "125/232",
    "name": "Steam Rage",
    "set": "dop",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/L5LW6t7.png",
    "uniqueId": "Steam Rage__dop"
  },
  {
    "id": "126/232",
    "name": "Telekinetic Bolt",
    "set": "dop",
    "rarity": "super rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15, Challenge :wisdom:Wisdom 15: Deal 10 damage and heal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/HT6wibT.png",
    "uniqueId": "Telekinetic Bolt__dop"
  },
  {
    "id": "127/232",
    "name": "Thunder Shout",
    "set": "dop",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": 10,
    "earth": 10,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Edwin Nebres, David Curiel ",
    "imageUrl": "https://i.imgur.com/M7UU2Sl.png",
    "uniqueId": "Thunder Shout__dop"
  },
  {
    "id": "128/232",
    "name": "Tornado Tackle",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 0,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Both players shuffle their Attack Decks and Attack Discard piles together.",
    "flavorText": "",
    "unique": false,
    "artist": "David Rodriguez, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/UmM3g0a.png",
    "uniqueId": "Tornado Tackle__dop"
  },
  {
    "id": "129/232",
    "name": "Torrent of Flame",
    "set": "dop",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/5gJNVIz.png",
    "uniqueId": "Torrent of Flame__dop"
  },
  {
    "id": "130/232",
    "name": "Toxic Gust",
    "set": "dop",
    "rarity": "super rare",
    "bp": 3,
    "base": 10,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Adrian Barrios, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/saKcoVM.png",
    "uniqueId": "Toxic Gust__dop"
  },
  {
    "id": "131/232",
    "name": "Unsanity",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": 5,
    "ability": "Challenge :wisdom:Wisdom 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/WD5dBmA.png",
    "uniqueId": "Unsanity__dop"
  },
  {
    "id": "132/232",
    "name": "Velocitrap",
    "set": "dop",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :speed:Speed 15: Deal 10 damage.",
    "flavorText": "Sorry for the run around.",
    "unique": false,
    "artist": "David Curiel, Francis Barrios",
    "imageUrl": "https://i.imgur.com/vp5XojQ.png",
    "uniqueId": "Velocitrap__dop"
  },
  {
    "id": "133/232",
    "name": "Vine Snare",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": ":earth:Earth: Opposing engaged Creature loses 25 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/heiHEm2.png",
    "uniqueId": "Vine Snare__dop"
  },
  {
    "id": "134/232",
    "name": "Viperlash",
    "set": "dop",
    "rarity": "rare",
    "bp": 3,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, David Curiel ",
    "imageUrl": "https://i.imgur.com/iJ4MAke.png",
    "uniqueId": "Viperlash__dop"
  },
  {
    "id": "135/232",
    "name": "Windslash",
    "set": "dop",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Your opponent turns all face-down Battlegear Cards they control face-up.",
    "flavorText": "",
    "unique": false,
    "artist": "David Rodriguez, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/zzMfHas.png",
    "uniqueId": "Windslash__dop"
  },
  {
    "id": "36/100",
    "name": "Accelerated Unity",
    "set": "zoth",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 5 damage for each Tribe you control beyond the first.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Edwin Nebres, Anthony Washington",
    "imageUrl": "https://i.imgur.com/pO6tfMG.png",
    "uniqueId": "Accelerated Unity__zoth"
  },
  {
    "id": "37/100",
    "name": "Acid Wash",
    "set": "zoth",
    "rarity": "super rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "Challenge :wisdom:Wisdom 15: Deal 10 damage.\r\n:water:Water: Uninfect all engaged Creatures. Those Creatures cannot be Infected.",
    "flavorText": "",
    "unique": false,
    "artist": "Gus Vazquez, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/tuISnvU.png",
    "uniqueId": "Acid Wash__zoth"
  },
  {
    "id": "38/100",
    "name": "Danihilation",
    "set": "zoth",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature is a Danian Creature, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Chris Dibari, David Curiel",
    "imageUrl": "https://i.imgur.com/GaYoMiG.png",
    "uniqueId": "Danihilation__zoth"
  },
  {
    "id": "39/100",
    "name": "Desiccate the Land",
    "set": "zoth",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": 0,
    "water": 5,
    "ability": ":earth:Earth: If an Attack Card named Desiccate the Land is in your attack discard pile, heal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Chris Dibari, Anthony Washington",
    "imageUrl": "https://i.imgur.com/JuUUjsK.png",
    "uniqueId": "Desiccate the Land__zoth"
  },
  {
    "id": "40/100",
    "name": "Elementalist's Psy-Blast",
    "set": "zoth",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 50: Deal 5 damage for each Elemental Type your engaged Creature has.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/rEG1Me9.png",
    "uniqueId": "Elementalist's Psy-Blast__zoth"
  },
  {
    "id": "41/100",
    "name": "Freeze Flash",
    "set": "zoth",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": 10,
    "earth": 10,
    "water": 0,
    "ability": ":water:Water: Opposing engaged Creature loses 25 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Patrick Gagne, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/DZG3DJ2.png",
    "uniqueId": "Freeze Flash__zoth"
  },
  {
    "id": "42/100",
    "name": "Gear Grind",
    "set": "zoth",
    "rarity": "rare",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Flip all face-up Battlegear face-down.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/RrYdutl.png",
    "uniqueId": "Gear Grind__zoth"
  },
  {
    "id": "43/100",
    "name": "Granite Balls",
    "set": "zoth",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If your engaged Creature is a Warrior, deal 10 damage unless your opponent removes a :genericmugic:Mugic counter from their engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/v2IQZUG.png",
    "uniqueId": "Granite Balls__zoth"
  },
  {
    "id": "44/100",
    "name": "Hive-phoon",
    "set": "zoth",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": 5,
    "ability": "If your engaged Creature is a Danian Creature, it gains :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "artist": "Gus Vazquez, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/kGvpzMA.png",
    "uniqueId": "Hive-phoon__zoth"
  },
  {
    "id": "45/100",
    "name": "Infight",
    "set": "zoth",
    "rarity": "super rare",
    "bp": 4,
    "base": 20,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature is a Danian Creature, Activate Hive. Hive cannot be Deactivated.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Khary Randolph",
    "imageUrl": "https://i.imgur.com/4OLMnQa.png",
    "uniqueId": "Infight__zoth"
  },
  {
    "id": "46/100",
    "name": "Malevolent Blast",
    "set": "zoth",
    "rarity": "uncommon",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 0,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Your engaged Creature loses :air:Air. Discard an Attack Card, then draw an Attack Card.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/B0EQxY4.png",
    "uniqueId": "Malevolent Blast__zoth"
  },
  {
    "id": "47/100",
    "name": "Mandiblor Might",
    "set": "zoth",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 5 damage for each Mandiblor Creature you control adjacent to your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, David Curiel",
    "imageUrl": "https://i.imgur.com/x5FiwtF.png",
    "uniqueId": "Mandiblor Might__zoth"
  },
  {
    "id": "48/100",
    "name": "Muge's Edge",
    "set": "zoth",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Your engaged Creature gains 10 :courage:Courage, :power:Power, :wisdom:Wisdom and:speed:Speed.\r\nIf your engaged Creature is a Muge, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/RRFUwuB.png",
    "uniqueId": "Muge's Edge__zoth"
  },
  {
    "id": "49/100",
    "name": "Mugician Steal",
    "set": "zoth",
    "rarity": "super rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 0,
    "ability": ":water:Water: Your engaged Creature loses :water:Water. Remove a :genericmugic:Mugic counter from the opposing engaged Creature. If you do, put a :genericmugic:Mugic counter on your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/gcm73qq.png",
    "uniqueId": "Mugician Steal__zoth"
  },
  {
    "id": "50/100",
    "name": "Pillar Quake",
    "set": "zoth",
    "rarity": "rare",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If the opposing engaged Creature is a Danian Creature, damage dealt by Pillar Quake is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Chris Dibari, David Curiel",
    "imageUrl": "https://i.imgur.com/JJhZT9Z.png",
    "uniqueId": "Pillar Quake__zoth"
  },
  {
    "id": "51/100",
    "name": "Reverberate",
    "set": "zoth",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If an Attack Card named Reverberate is in your Attack Discard pile, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/4SZVkUR.png",
    "uniqueId": "Reverberate__zoth"
  },
  {
    "id": "52/100",
    "name": "Scout's Strike",
    "set": "zoth",
    "rarity": "common",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 50: Deal 10 damage.\r\nIf your engaged Creature is a Scout, look at opposing player's Attack and Mugic hands.",
    "flavorText": "",
    "unique": false,
    "artist": "Patrick Gange, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/Iuaw86g.png",
    "uniqueId": "Scout's Strike__zoth"
  },
  {
    "id": "53/100",
    "name": "Strike of the Meek",
    "set": "zoth",
    "rarity": "ultra rare",
    "bp": 5,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has 30 or less Scanned Energy, deal 50 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Chris Dibari, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/6eRoAAW.png",
    "uniqueId": "Strike of the Meek__zoth"
  },
  {
    "id": "54/100",
    "name": "Sunder Ground",
    "set": "zoth",
    "rarity": "uncommon",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 10,
    "water": null,
    "ability": ":earth:Earth: Your engaged Creature loses :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/MS8ldd0.png",
    "uniqueId": "Sunder Ground__zoth"
  },
  {
    "id": "55/100",
    "name": "Terraport",
    "set": "zoth",
    "rarity": "rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": ":earth:Earth: Your engaged Creature loses :earth:Earth. Look at the top two cards of your Location Deck and choose one. It becomes the active Location. Put the other on the bottom of your deck.",
    "flavorText": "",
    "unique": false,
    "artist": "Steve Ellis",
    "imageUrl": "https://i.imgur.com/ogjgLLM.png",
    "uniqueId": "Terraport__zoth"
  },
  {
    "id": "36/100",
    "name": "Apoc-eclipse",
    "set": "ss",
    "rarity": "ultra rare",
    "bp": 3,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": 5,
    "water": 5,
    "ability": ":fire:Fire, :air:Air, :earth:Earth, :water:Water: Flip opposing engaged Creature's Battlegear face-down, draw an Attack Card, discard an Attack Card, deal 5 damage and gain 5 Energy.",
    "flavorText": "",
    "unique": true,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/P1NUq6L.png",
    "uniqueId": "Apoc-eclipse__ss"
  },
  {
    "id": "37/100",
    "name": "Arborsmash",
    "set": "ss",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 50: Your engaged Creature gains :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/rPYgECh.png",
    "uniqueId": "Arborsmash__ss"
  },
  {
    "id": "38/100",
    "name": "Blaze Barrage",
    "set": "ss",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": 0,
    "air": 5,
    "earth": null,
    "water": 5,
    "ability": ":fire:Fire, :air:Air: Draw an Attack Card and discard an Attack Card.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/918Fmam.png",
    "uniqueId": "Blaze Barrage__ss"
  },
  {
    "id": "39/100",
    "name": "Blind Fury",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 10,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has Recklessness, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/dAXp2If.png",
    "uniqueId": "Blind Fury__ss"
  },
  {
    "id": "40/100",
    "name": "Cyclone Slam",
    "set": "ss",
    "rarity": "super rare",
    "bp": 3,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": null,
    "ability": "If your engaged Creature is a Warbeast Creature, deal 20 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/TMIsaoO.png",
    "uniqueId": "Cyclone Slam__ss"
  },
  {
    "id": "41/100",
    "name": "Dexterous Storm",
    "set": "ss",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 50: Your engaged Creature gains :air:Air.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/qtLHr5J.png",
    "uniqueId": "Dexterous Storm__ss"
  },
  {
    "id": "42/100",
    "name": "Elemental Oxidation",
    "set": "ss",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": 0,
    "water": 5,
    "ability": ":fire:Fire, :earth:Earth: Flip all Battlegear equipped to the opposing engaged Creature face-down.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/ykdRp8H.png",
    "uniqueId": "Elemental Oxidation__ss"
  },
  {
    "id": "43/100",
    "name": "Enlightened Tenacity",
    "set": "ss",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "Stat Check :courage:Courage 30: Deal 5 damage.\r\nStat Check :courage:Courage 50: Deal 5 damage.\r\nStat Check :courage:Courage 70: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/mbg0NmL.png",
    "uniqueId": "Enlightened Tenacity__ss"
  },
  {
    "id": "44/100",
    "name": "Fear Fight",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "Stat Fail :courage:Courage 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/d9aizQW.png",
    "uniqueId": "Fear Fight__ss"
  },
  {
    "id": "45/100",
    "name": "Force Strike",
    "set": "ss",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 30: Deal 5 damage.\r\nStat Check :power:Power 50: Deal 5 damage.\r\nStat Check :power:Power 70: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/d3xBR9G.png",
    "uniqueId": "Force Strike__ss"
  },
  {
    "id": "46/100",
    "name": "Hampering Winds",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Stat Fail :speed:Speed 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/liwmPSH.png",
    "uniqueId": "Hampering Winds__ss"
  },
  {
    "id": "47/100",
    "name": "Harnessed Rage",
    "set": "ss",
    "rarity": "rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has Recklessness, deal damage equal to its Recklessness value.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/DBc2h1K.png",
    "uniqueId": "Harnessed Rage__ss"
  },
  {
    "id": "48/100",
    "name": "Heptagon Hail",
    "set": "ss",
    "rarity": "ultra rare",
    "bp": 4,
    "base": 35,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Put a :genericmugic:Mugic counter on each Creature controlled by an opponent.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/LbgSHNi.png",
    "uniqueId": "Heptagon Hail__ss"
  },
  {
    "id": "49/100",
    "name": "Hurlicane",
    "set": "ss",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 10,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Your engaged Creature loses :air:Air.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/sT0CQFf.png",
    "uniqueId": "Hurlicane__ss"
  },
  {
    "id": "50/100",
    "name": "Hydro Balls",
    "set": "ss",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 50: Your engaged Creature gains :water:Water.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/H4z7WFP.png",
    "uniqueId": "Hydro Balls__ss"
  },
  {
    "id": "51/100",
    "name": "Liquescent Swirl",
    "set": "ss",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": ":water:Water: Your engaged Creature loses :water:Water.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/YCW6mfX.png",
    "uniqueId": "Liquescent Swirl__ss"
  },
  {
    "id": "52/100",
    "name": "Matagore",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If your engaged Creature is Mipedian Creature, it gains :air:Air.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/uYNS4sn.png",
    "uniqueId": "Matagore__ss"
  },
  {
    "id": "53/100",
    "name": "Mind Strike",
    "set": "ss",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Check :wisdom:Wisdom 30: Deal 5 damage.\r\nStat Check :wisdom:Wisdom 50: Deal 5 damage.\r\nStat Check :wisdom:Wisdom 70: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/xrqtMwj.png",
    "uniqueId": "Mind Strike__ss"
  },
  {
    "id": "54/100",
    "name": "Progressive Speed",
    "set": "ss",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 30: Deal 5 damage.\r\nStat Check :speed:Speed 50: Deal 5 damage.\r\nStat Check :speed:Speed 70: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/uOOy17e.png",
    "uniqueId": "Progressive Speed__ss"
  },
  {
    "id": "55/100",
    "name": "Purifying Mud",
    "set": "ss",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": 5,
    "water": 0,
    "ability": ":earth:Earth, :water:Water: Deal 5 damage, then gain 5 Energy.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Keith Conroy",
    "imageUrl": "https://i.imgur.com/BOcydOw.png",
    "uniqueId": "Purifying Mud__ss"
  },
  {
    "id": "56/100",
    "name": "Reactive Resolution",
    "set": "ss",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15: Deal 5 damage.\r\nChallenge :speed:Speed 15: Deal 5 damage.\r\nIf you win both challenges, deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/O1nSnar.png",
    "uniqueId": "Reactive Resolution__ss"
  },
  {
    "id": "57/100",
    "name": "Reckless Defeat",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If the opposing engaged Creature has Recklessness, deal damage equal to that Creature's Recklessness value.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/D2erauG.png",
    "uniqueId": "Reckless Defeat__ss"
  },
  {
    "id": "58/100",
    "name": "Reckless Reproach",
    "set": "ss",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature has Recklessness, deal damage equal to that Creature's Recklessness value.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/ijGpSHU.png",
    "uniqueId": "Reckless Reproach__ss"
  },
  {
    "id": "59/100",
    "name": "Rot Cloud",
    "set": "ss",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature has :air:Air, deal 5 damage. \r\nIf the opposing engaged Creature has :earth:Earth, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/lRKVJsC.png",
    "uniqueId": "Rot Cloud__ss"
  },
  {
    "id": "60/100",
    "name": "Slashclaw",
    "set": "ss",
    "rarity": "super rare",
    "bp": 5,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has Recklessness, deal damage equal to twice its Recklessness value.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez",
    "imageUrl": "https://i.imgur.com/o63tfcg.png",
    "uniqueId": "Slashclaw__ss"
  },
  {
    "id": "61/100",
    "name": "Stupefying Tide",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Fail :wisdom:Wisdom 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/HYhEeyc.png",
    "uniqueId": "Stupefying Tide__ss"
  },
  {
    "id": "62/100",
    "name": "Symmetry Slam",
    "set": "ss",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 5 damage for each Elemental Type shared by both engaged Creatures.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/KUAHns7.png",
    "uniqueId": "Symmetry Slam__ss"
  },
  {
    "id": "63/100",
    "name": "Trampling Tackle",
    "set": "ss",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 10,
    "water": null,
    "ability": "If your engaged Creature has Recklessness, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/NEwBPqZ.png",
    "uniqueId": "Trampling Tackle__ss"
  },
  {
    "id": "64/100",
    "name": "Twister of Elements",
    "set": "ss",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": 0,
    "ability": ":air:Air, :water:Water: Search your Attack Deck for up to three Attack Cards and put them in your Attack Discard pile, then shuffle your Attack Deck.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/DpIg8Ue.png",
    "uniqueId": "Twister of Elements__ss"
  },
  {
    "id": "65/100",
    "name": "Web Cocoon",
    "set": "ss",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 50: Your engaged Creature gains :fire:Fire.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/4o3ZTjF.png",
    "uniqueId": "Web Cocoon__ss"
  },
  {
    "id": "68/222",
    "name": "Burning Rain",
    "set": "btd",
    "rarity": "super rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If Burning Rain would deal more than 10 damage, it deals 10 damage instead.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/ptYt1rp.png",
    "uniqueId": "Burning Rain__btd"
  },
  {
    "id": "69/222",
    "name": "Confusion",
    "set": "btd",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Gain 10 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/Q2An9kC.png",
    "uniqueId": "Confusion__btd"
  },
  {
    "id": "70/222",
    "name": "Daunting Bravery",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15: Deal 10 damage.\r\nStat Check :courage:Courage 50: Opposing engaged Creature loses 15 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "Edwin Nebres, Andrew Bradshaw, David Curiel",
    "imageUrl": "https://i.imgur.com/8mMnHVd.png",
    "uniqueId": "Daunting Bravery__btd"
  },
  {
    "id": "71/222",
    "name": "Deceleration",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Fail :speed:Speed 100: Deal 5 damage.\r\nStat Fail :speed:Speed 50: Deal 10 damage.\r\nStat Fail :speed:Speed 5: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/NosnR3p.png",
    "uniqueId": "Deceleration__btd"
  },
  {
    "id": "73/222",
    "name": "Deluge of Doom",
    "set": "btd",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 10,
    "water": 10,
    "ability": ":water:Water: Opposing engaged Creature loses 25 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/o626Nvc.png",
    "uniqueId": "Deluge of Doom__btd"
  },
  {
    "id": "74/222",
    "name": "Disempowerment Combo",
    "set": "btd",
    "rarity": "super rare",
    "bp": 4,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Fail :courage:Courage 30: Deal 10 damage.\r\nStat Fail :power:Power 30: Deal 10 damage.\r\nStat Fail :wisdom:Wisdom 30: Deal 10 damage.\r\nStat Fail :speed:Speed 30: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/UBTUSVh.png",
    "uniqueId": "Disempowerment Combo__btd"
  },
  {
    "id": "75/222",
    "name": "Dry Liquid",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :power:Power 15: Deal 10 damage.\r\nStat Check :power:Power 50: Opposing engaged Creature loses 15 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/i9dHots.png",
    "uniqueId": "Dry Liquid__btd"
  },
  {
    "id": "76/222",
    "name": "Electro-Web",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 0,
    "ability": "Challenge :power:Power 30: Deal 10 damage. If you lose this Challenge, gain 15 :power:Power.\r\nChallenge :speed:Speed 30: Deal 10 damage. If you lose this Challenge, gain 15 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/EvzuS1Q.png",
    "uniqueId": "Electro-Web__btd"
  },
  {
    "id": "78/222",
    "name": "Fear Projection",
    "set": "btd",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Opposing engaged Creature loses 20 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/DVD48Xi.png",
    "uniqueId": "Fear Projection__btd"
  },
  {
    "id": "79/222",
    "name": "Flaming Coals",
    "set": "btd",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "Untargetable.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/iJuPdcW.png",
    "uniqueId": "Flaming Coals__btd"
  },
  {
    "id": "81/222",
    "name": "Ghost Gouge",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Check :wisdom:Wisdom 50: Deal 5 damage.\r\nStat Check :speed:Speed 50: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/Mx4LRyx.png",
    "uniqueId": "Ghost Gouge__btd"
  },
  {
    "id": "82/222",
    "name": "Gravity Slam",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Fail :power:Power 100: Deal 5 damage.\r\nStat Fail :power:Power 50: Deal 10 damage.\r\nStat Fail :power:Power 5: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/cLyTqDF.png",
    "uniqueId": "Gravity Slam__btd"
  },
  {
    "id": "83/222",
    "name": "Hammer Dash",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 50: Deal 5 damage.\r\nStat Check :power:Power 50: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/Mwp2SDK.png",
    "uniqueId": "Hammer Dash__btd"
  },
  {
    "id": "85/222",
    "name": "Heat Rage",
    "set": "btd",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": ":fire:Fire: Gain 10 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/fE27hPI.png",
    "uniqueId": "Heat Rage__btd"
  },
  {
    "id": "86/222",
    "name": "Ice Disks",
    "set": "btd",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": 10,
    "water": 10,
    "ability": "Your opponent cannot play activated abilities. (Your opponent can activate abilities before this resolves.)",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/zFlxMsr.png",
    "uniqueId": "Ice Disks__btd"
  },
  {
    "id": "87/222",
    "name": "Ice Sheet",
    "set": "btd",
    "rarity": "super rare",
    "bp": 3,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": ":water:Water: Deal an additional 5 damage for each :genericmugic:Mugic counter on your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/ZSwAmXU.png",
    "uniqueId": "Ice Sheet__btd"
  },
  {
    "id": "89/222",
    "name": "Mind Grind",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Fail :wisdom:Wisdom 100: Deal 5 damage.\r\nStat Fail :wisdom:Wisdom 50: Deal 10 damage.\r\nStat Fail :wisdom:Wisdom 5: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/1gCY54I.png",
    "uniqueId": "Mind Grind__btd"
  },
  {
    "id": "90/222",
    "name": "Mindful Finish",
    "set": "btd",
    "rarity": "super rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Fail :courage:Courage, :power:Power, :wisdom:Wisdom and:speed:Speed 20: Deal 25 damage.",
    "flavorText": "",
    "unique": true,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/pRTVG1N.png",
    "uniqueId": "Mindful Finish__btd"
  },
  {
    "id": "91/222",
    "name": "Mindsink",
    "set": "btd",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Opposing engaged Creature loses 20 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/yvXIacD.png",
    "uniqueId": "Mindsink__btd"
  },
  {
    "id": "92/222",
    "name": "Minor Roar",
    "set": "btd",
    "rarity": "super rare",
    "bp": 4,
    "base": 5,
    "fire": 5,
    "air": 5,
    "earth": 5,
    "water": 5,
    "ability": "Deal an additional 5 damage for each :genericmugic:Mugic counter on your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/YvqJxPP.png",
    "uniqueId": "Minor Roar__btd"
  },
  {
    "id": "93/222",
    "name": "Neuro Freeze",
    "set": "btd",
    "rarity": "super rare",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "If the opposing engaged Creature has :water:Water, damage dealt by Neuro Freeze is reduced by 10.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/f01R4sU.png",
    "uniqueId": "Neuro Freeze__btd"
  },
  {
    "id": "94/222",
    "name": "Outsmart",
    "set": "btd",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your Creature's :wisdom:Wisdom is more than opposing engaged Creature's :speed:Speed, deal 5 damage. If it isn't, opposing engaged Creature loses 10 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/VuGyNA5.png",
    "uniqueId": "Outsmart__btd"
  },
  {
    "id": "95/222",
    "name": "Outwit",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 50: Deal 5 damage.\r\nStat Check :wisdom:Wisdom 50: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/EdgYJjp.png",
    "uniqueId": "Outwit__btd"
  },
  {
    "id": "96/222",
    "name": "Perplexing Heat",
    "set": "btd",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": ":fire:Fire: Opposing engaged Creature loses 25 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/CHlyPHD.png",
    "uniqueId": "Perplexing Heat__btd"
  },
  {
    "id": "97/222",
    "name": "Piercing Brilliance",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :wisdom:Wisdom 15: Deal 10 damage.\r\nStat Check :wisdom:Wisdom 50: Opposing engaged Creature loses 15 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/yBgQ717.png",
    "uniqueId": "Piercing Brilliance__btd"
  },
  {
    "id": "98/222",
    "name": "Plasmarrow",
    "set": "btd",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": 10,
    "air": 10,
    "earth": null,
    "water": null,
    "ability": "Opposing engaged Creature cannot be healed. (Opposing engaged Creatures can be healed before this resolves.)",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/aG2RLax.png",
    "uniqueId": "Plasmarrow__btd"
  },
  {
    "id": "99/222",
    "name": "Poison Panic",
    "set": "btd",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "If an Attack Card named Poison Panic is in your attack discard pile, damage dealt by Poison Panic is reduced by 5.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/erY1nXO.png",
    "uniqueId": "Poison Panic__btd"
  },
  {
    "id": "100/222",
    "name": "Poison Sphere",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :speed:Speed 15: Deal 10 damage.\r\nStat Check :speed:Speed 50: Opposing engaged Creature loses 15 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/3sk9Yh4.png",
    "uniqueId": "Poison Sphere__btd"
  },
  {
    "id": "101/222",
    "name": "Power Punch",
    "set": "btd",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your Creature's :power:Power is more than opposing engaged Creature's :wisdom:Wisdom, deal 5 damage. If it isn't, opposing engaged Creature loses 10 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/5rSpmPM.png",
    "uniqueId": "Power Punch__btd"
  },
  {
    "id": "102/222",
    "name": "Primal Smash",
    "set": "btd",
    "rarity": "ultra rare",
    "bp": 1,
    "base": 20,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": true,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/8wEQYc9.png",
    "uniqueId": "Primal Smash__btd"
  },
  {
    "id": "103/222",
    "name": "Psi-mageddon",
    "set": "btd",
    "rarity": "super rare",
    "bp": 5,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 20 damage for each Minion Creature Card in your general discard pile.",
    "flavorText": "",
    "unique": true,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/3VvsHTO.png",
    "uniqueId": "Psi-mageddon__btd"
  },
  {
    "id": "104/222",
    "name": "Psychodrain",
    "set": "btd",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Opposing engaged Creature loses 20 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/1k3CwM3.png",
    "uniqueId": "Psychodrain__btd"
  },
  {
    "id": "106/222",
    "name": "Radical Ice Balls",
    "set": "btd",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": null,
    "ability": ":earth:Earth: Gain 10 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/mT2mBkF.png",
    "uniqueId": "Radical Ice Balls__btd"
  },
  {
    "id": "108/222",
    "name": "Screeching Scare",
    "set": "btd",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your Creature's :courage:Courage is more than opposing engaged Creature's :power:Power, deal 5 damage. If it isn't, opposing engaged Creature loses 10 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/ZstLueg.png",
    "uniqueId": "Screeching Scare__btd"
  },
  {
    "id": "111/222",
    "name": "Sink Scream",
    "set": "btd",
    "rarity": "ultra rare",
    "bp": 5,
    "base": 0,
    "fire": 0,
    "air": 0,
    "earth": 0,
    "water": 0,
    "ability": ":fire:Fire: Reduce opposing engaged Creature's :power:Power to 0.\r\n:air:Air: Reduce opposing engaged Creature's :speed:Speed to 0.\r\n:earth:Earth: Reduce opposing engaged Creature's :courage:Courage to 0.\r\n:water:Water: Reduce opposing engaged Creature's :wisdom:Wisdom to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/bQmxcdN.png",
    "uniqueId": "Sink Scream__btd"
  },
  {
    "id": "112/222",
    "name": "Slowsand",
    "set": "btd",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": 10,
    "earth": 10,
    "water": null,
    "ability": ":earth:Earth: Opposing engaged Creature loses 25 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/xdipKOt.png",
    "uniqueId": "Slowsand__btd"
  },
  {
    "id": "113/222",
    "name": "Snare Attack",
    "set": "btd",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your Creature's :speed:Speed is more than opposing engaged Creature's :courage:Courage, deal 5 damage. If it isn't, opposing engaged Creature loses 10 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/2ogzsu2.png",
    "uniqueId": "Snare Attack__btd"
  },
  {
    "id": "115/222",
    "name": "Streak Strike",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "Stat Check :speed:Speed 50: Deal 5 damage.\r\nStat Check :courage:Courage 50: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/alzM0wy.png",
    "uniqueId": "Streak Strike__btd"
  },
  {
    "id": "117/222",
    "name": "Terror-Fying Tackle",
    "set": "btd",
    "rarity": "uncommon",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Fail :courage:Courage 100: Deal 5 damage.\r\nStat Fail :courage:Courage 50: Deal 10 damage.\r\nStat Fail :courage:Courage 5: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/56d1zPn.png",
    "uniqueId": "Terror-Fying Tackle__btd"
  },
  {
    "id": "118/222",
    "name": "Timeslow",
    "set": "btd",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Opposing engaged Creature loses 20 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/KsCuA3Z.png",
    "uniqueId": "Timeslow__btd"
  },
  {
    "id": "120/222",
    "name": "Torrent of Water",
    "set": "btd",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": ":water:Water: Gain 10 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/W5CQ69C.png",
    "uniqueId": "Torrent of Water__btd"
  },
  {
    "id": "124/222",
    "name": "Whirling Wail",
    "set": "btd",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": 10,
    "earth": 10,
    "water": null,
    "ability": "Your opponent cannot play Mugic Cards. (Your opponent can play Mugic Cards before this resolves.)",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/heSn6lc.png",
    "uniqueId": "Whirling Wail__btd"
  },
  {
    "id": "125/222",
    "name": "Whirlwind Scythes",
    "set": "btd",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": 10,
    "air": 10,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Opposing engaged Creature loses 25 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/W2k4QdE.png",
    "uniqueId": "Whirlwind Scythes__btd"
  },
  {
    "id": "47/100",
    "name": "Aftermath Feint",
    "set": "roto",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "When your engaged Creature is destroyed this turn, draw two Attack Cards and discard two Attack Cards.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/70ZiyVu.png",
    "uniqueId": "Aftermath Feint__roto"
  },
  {
    "id": "48/100",
    "name": "Caustic Cascade",
    "set": "roto",
    "rarity": "uncommon",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 20,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/3ejuJ4r.png",
    "uniqueId": "Caustic Cascade__roto"
  },
  {
    "id": "49/100",
    "name": "Electric Rain",
    "set": "roto",
    "rarity": "super rare",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "The opposing engaged Creature must pay an additional :genericmugic:to play abilities which cost one or more Mugic counters.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/5i6d3fa.png",
    "uniqueId": "Electric Rain__roto"
  },
  {
    "id": "50/100",
    "name": "Fire Stream",
    "set": "roto",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature is equipped, damage dealt by Fire Stream is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/8BbMHUR.png",
    "uniqueId": "Fire Stream__roto"
  },
  {
    "id": "51/100",
    "name": "Fluidmight",
    "set": "roto",
    "rarity": "common",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "When a Fluidmorpher Creature deals damage with Fluidmight, put a Mugic counter on it",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/I2ftjfr.png",
    "uniqueId": "Fluidmight__roto"
  },
  {
    "id": "52/100",
    "name": "Force Balls",
    "set": "roto",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If you control non-OverWorld Creatures, damage dealt by Force Balls is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/oMpuD7X.png",
    "uniqueId": "Force Balls__roto"
  },
  {
    "id": "53/100",
    "name": "Invader's Tactics",
    "set": "roto",
    "rarity": "rare",
    "bp": 1,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 0,
    "ability": "If your opponent controls the active Location, deal an additional 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/64OFQQ5.png",
    "uniqueId": "Invader's Tactics__roto"
  },
  {
    "id": "54/100",
    "name": "Kha'rall Crush",
    "set": "roto",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If your engaged Creature is equipped with a Shard, deal an additional 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/VWHNFYG.png",
    "uniqueId": "Kha'rall Crush__roto"
  },
  {
    "id": "55/100",
    "name": "Marksman's Preparation",
    "set": "roto",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 0,
    "earth": null,
    "water": null,
    "ability": "The opposing engaged Creature cannot have Mugic counters put on it.\r\nYou can discard another card named Marksman's Preparation. If you do, deal an additional 30 damage and draw an Attack Card.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/2TZOcPK.png",
    "uniqueId": "Marksman's Preparation__roto"
  },
  {
    "id": "56/100",
    "name": "Mightswing",
    "set": "roto",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "If you control non-UnderWorld Creatures, damage dealt by Mightswing is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/dZ7kKig.png",
    "uniqueId": "Mightswing__roto"
  },
  {
    "id": "57/100",
    "name": "Petrifying Power",
    "set": "roto",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If your opponent controls the active Location, damage dealt by Petrifying:power:Power is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/RvoLsHb.png",
    "uniqueId": "Petrifying Power__roto"
  },
  {
    "id": "58/100",
    "name": "Poison Steam",
    "set": "roto",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "If you have fewer Mugic Cards in your hand than your opponent, damage dealt by Poison Steam is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/IU91Ma4.png",
    "uniqueId": "Poison Steam__roto"
  },
  {
    "id": "59/100",
    "name": "Rage of Aa'une",
    "set": "roto",
    "rarity": "rare",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If your engaged Creature is a Chieftain Creature, deal an additional 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/IttZBsM.png",
    "uniqueId": "Rage of Aa'une__roto"
  },
  {
    "id": "60/100",
    "name": "Rancorous Projection",
    "set": "roto",
    "rarity": "super rare",
    "bp": 2,
    "base": 40,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "For each Discipline over 50 the opposing engaged Creature has, damage dealt by Rancorous Projection is reduced by 10.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/hWhzHWn.png",
    "uniqueId": "Rancorous Projection__roto"
  },
  {
    "id": "61/100",
    "name": "Sandstrike",
    "set": "roto",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": null,
    "ability": "If you control non-Mipedian Creatures, damage dealt by Sandstrike is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/wAUO2ya.png",
    "uniqueId": "Sandstrike__roto"
  },
  {
    "id": "62/100",
    "name": "Solar Flare",
    "set": "roto",
    "rarity": "rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "Remove X Mugic counters from the opposing engaged Creature, where X is the number of Mugic counters on your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/JW0GT1C.png",
    "uniqueId": "Solar Flare__roto"
  },
  {
    "id": "63/100",
    "name": "Supercooled Rain",
    "set": "roto",
    "rarity": "super rare",
    "bp": 5,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 25,
    "ability": "Your opponent removes a total of 4 Mugic counters from among any Creatures they control.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/cjObAs9.png",
    "uniqueId": "Supercooled Rain__roto"
  },
  {
    "id": "64/100",
    "name": "Swarming Destruction",
    "set": "roto",
    "rarity": "uncommon",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": "If you control non-Danian Creatures, damage dealt by Swarming Destruction is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/m15Tkur.png",
    "uniqueId": "Swarming Destruction__roto"
  },
  {
    "id": "65/100",
    "name": "Tainted Thunderstorm",
    "set": "roto",
    "rarity": "rare",
    "bp": 4,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 20,
    "ability": "Challenge :genericmugic:Mugic counters 1: Deal 20 damage",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/p7vxrNO.png",
    "uniqueId": "Tainted Thunderstorm__roto"
  },
  {
    "id": "66/100",
    "name": "Tidal Surge",
    "set": "roto",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If the opposing engaged Creature has a Mugic counter, damage dealt by Tidal Surge is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/hoaVg6X.png",
    "uniqueId": "Tidal Surge__roto"
  },
  {
    "id": "36/100",
    "name": "Academy Strike",
    "set": "tott",
    "rarity": "rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 100: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/0lIjk6D.png",
    "uniqueId": "Academy Strike__tott"
  },
  {
    "id": "37/100",
    "name": "Acceleration",
    "set": "tott",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :speed:Speed 5: Deal 10 damage.\r\nChallenge :speed:Speed 30: Deal 10 damage.\r\nChallenge :speed:Speed 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/PJeKxjU.png",
    "uniqueId": "Acceleration__tott"
  },
  {
    "id": "38/100",
    "name": "Aqua Recoil",
    "set": "tott",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 0,
    "water": 0,
    "ability": ":water:Water: Heal 5 damage.\r\n:earth:Earth: Gain 10 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/H1HgasL.png",
    "uniqueId": "Aqua Recoil__tott"
  },
  {
    "id": "39/100",
    "name": "Charge of the Brave",
    "set": "tott",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 5: Deal 10 damage.\r\nChallenge :courage:Courage 30: Deal 10 damage.\r\nChallenge :courage:Courage 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/y8btd1d.png",
    "uniqueId": "Charge of the Brave__tott"
  },
  {
    "id": "40/100",
    "name": "Flamebloom",
    "set": "tott",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": 0,
    "air": null,
    "earth": null,
    "water": 0,
    "ability": ":fire:Fire: Heal 5 damage.\r\n:water:Water: Gain 10 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/amRz2QH.png",
    "uniqueId": "Flamebloom__tott"
  },
  {
    "id": "41/100",
    "name": "Flying Advantage",
    "set": "tott",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": 0,
    "air": 0,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Heal 5 damage.\r\n:fire:Fire: Gain 10 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/hxkOjkn.png",
    "uniqueId": "Flying Advantage__tott"
  },
  {
    "id": "42/100",
    "name": "Glacial Balls",
    "set": "tott",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 100: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/VaMXat4.png",
    "uniqueId": "Glacial Balls__tott"
  },
  {
    "id": "43/100",
    "name": "Infectious Implosion",
    "set": "tott",
    "rarity": "rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If the opposing engaged Creature is Infected, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Chris Fisher, HotShots VFX",
    "imageUrl": "https://i.imgur.com/U5jnt9U.png",
    "uniqueId": "Infectious Implosion__tott"
  },
  {
    "id": "44/100",
    "name": "Landgore",
    "set": "tott",
    "rarity": "rare",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": 5,
    "water": 5,
    "ability": "",
    "flavorText": "",
    "unique": true,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/cUd1e1J.png",
    "uniqueId": "Landgore__tott"
  },
  {
    "id": "45/100",
    "name": "Magma Hack",
    "set": "tott",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 100: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/6ThAOtH.png",
    "uniqueId": "Magma Hack__tott"
  },
  {
    "id": "46/100",
    "name": "Mindrazor",
    "set": "tott",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :wisdom:Wisdom 5: Deal 10 damage.\r\nChallenge :wisdom:Wisdom 30: Deal 10 damage.\r\nChallenge :wisdom:Wisdom 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/b4sogvM.png",
    "uniqueId": "Mindrazor__tott"
  },
  {
    "id": "47/100",
    "name": "Morphwrath",
    "set": "tott",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Challenge :genericmugic:Mugic counters 1: Deal 5 damage.\r\nChallenge :genericmugic:Mugic counters 3: Deal 5 damage.\r\nChallenge :genericmugic:Mugic counters 5: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/8aPJWul.png",
    "uniqueId": "Morphwrath__tott"
  },
  {
    "id": "48/100",
    "name": "Prowl Strike",
    "set": "tott",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :power:Power 5: Deal 10 damage.\r\nChallenge :power:Power 30: Deal 10 damage.\r\nChallenge :power:Power 50: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/tbaETDS.png",
    "uniqueId": "Prowl Strike__tott"
  },
  {
    "id": "49/100",
    "name": "Reefquake",
    "set": "tott",
    "rarity": "uncommon",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 5 damage for each Kha'rall Creature you control.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/iNrouy0.png",
    "uniqueId": "Reefquake__tott"
  },
  {
    "id": "50/100",
    "name": "Sediment Stormshield",
    "set": "tott",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 0,
    "earth": 0,
    "water": null,
    "ability": ":earth:Earth: Heal 5 damage.\r\n:air:Air: Gain 10 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/k4QA992.png",
    "uniqueId": "Sediment Stormshield__tott"
  },
  {
    "id": "51/100",
    "name": "Slime Slam",
    "set": "tott",
    "rarity": "uncommon",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": "Stat Fail :power:Power 50: Flip all Battlegear equipped to the opposing engaged Creature face-down.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/jkm3N2I.png",
    "uniqueId": "Slime Slam__tott"
  },
  {
    "id": "52/100",
    "name": "Ultimate Warstance",
    "set": "tott",
    "rarity": "super rare",
    "bp": 4,
    "base": 5,
    "fire": null,
    "air": 10,
    "earth": 10,
    "water": null,
    "ability": ":earth:Earth, :air:Air: The next attack played this combat deals 0 damage.",
    "flavorText": "",
    "unique": true,
    "artist": "Chris Fisher, HotShots VFX",
    "imageUrl": "https://i.imgur.com/mYGAgOh.png",
    "uniqueId": "Ultimate Warstance__tott"
  },
  {
    "id": "53/100",
    "name": "Unarmed Brawl Bash",
    "set": "tott",
    "rarity": "rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 100: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/G5lcVp6.png",
    "uniqueId": "Unarmed Brawl Bash__tott"
  },
  {
    "id": "54/100",
    "name": "Vigorous Gust",
    "set": "tott",
    "rarity": "uncommon",
    "bp": 2,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Relocate both engaged Creatures to any unoccupied space on the Battleboard adjacent to either of them.",
    "flavorText": "",
    "unique": false,
    "artist": "Chris Fisher, Imaginary Friends Strudios",
    "imageUrl": "https://i.imgur.com/5NTiaHq.png",
    "uniqueId": "Vigorous Gust__tott"
  },
  {
    "id": "55/100",
    "name": "Winterclaw",
    "set": "tott",
    "rarity": "super rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": 10,
    "earth": null,
    "water": 10,
    "ability": "If the active Location's Initiative is a Discipline, deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Etienne St.Laurent, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/DuCJb1F.png",
    "uniqueId": "Winterclaw__tott"
  },
  {
    "id": "39/100",
    "name": "Alacritous Force",
    "set": "fun",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 60: Deal 10 damage.\r\nStat Check :speed:Speed 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/Gqly5dB.png",
    "uniqueId": "Alacritous Force__fun"
  },
  {
    "id": "40/100",
    "name": "Braveglint",
    "set": "fun",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 60: Deal 10 damage.\r\nStat Check :speed:Speed 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/aFRloV1.png",
    "uniqueId": "Braveglint__fun"
  },
  {
    "id": "41/100",
    "name": "Clashjet",
    "set": "fun",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 50: Deal 5 Damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/XaLU3Ia.png",
    "uniqueId": "Clashjet__fun"
  },
  {
    "id": "42/100",
    "name": "Coral Balls",
    "set": "fun",
    "rarity": "super rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If your engaged Creature has Defender, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Sanford Greene, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/77pTJge.png",
    "uniqueId": "Coral Balls__fun"
  },
  {
    "id": "43/100",
    "name": "Directed Bravery",
    "set": "fun",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 60: Deal 10 damage.\r\nStat Check :wisdom:Wisdom 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/L6qCrFx.png",
    "uniqueId": "Directed Bravery__fun"
  },
  {
    "id": "44/100",
    "name": "Discipline Destruction",
    "set": "fun",
    "rarity": "super rare",
    "bp": 4,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :courage:Courage 15: Deal 10 damage.\r\nChallenge :power:Power 15: Deal 10 damage.\r\nChallenge :wisdom:Wisdom 15: Deal 10 damage.\r\nChallenge :speed:Speed 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/cbmL3nR.png",
    "uniqueId": "Discipline Destruction__fun"
  },
  {
    "id": "45/100",
    "name": "Fearless Strike",
    "set": "fun",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 60: Deal 10 damage.\r\nStat Check :power:Power 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/qmDeocs.png",
    "uniqueId": "Fearless Strike__fun"
  },
  {
    "id": "46/100",
    "name": "Fire Ring",
    "set": "fun",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "When:fire:Fire Ring is played, deal 10 damage to your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Sanford Greene, Etienne St.Laurent, Andrew Bradshaw",
    "imageUrl": "https://i.imgur.com/IoL4RNj.png",
    "uniqueId": "Fire Ring__fun"
  },
  {
    "id": "47/100",
    "name": "Funnel Blast",
    "set": "fun",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": null,
    "ability": "Stat Check :speed:Speed 50: Deal 5 Damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/sysYpze.png",
    "uniqueId": "Funnel Blast__fun"
  },
  {
    "id": "48/100",
    "name": "Geyser Gush",
    "set": "fun",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": "Stat Check :courage:Courage 50: Deal 5 Damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/2m2290J.png",
    "uniqueId": "Geyser Gush__fun"
  },
  {
    "id": "49/100",
    "name": "Grantkae's Stance",
    "set": "fun",
    "rarity": "super rare",
    "bp": 3,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If you control:\r\nAn OverWorld Creature, gain 10 Energy. \r\nAn UnderWorld Creature, destroy all Battlegear equipped to the opposing engaged Creature.\r\nA Mipedian Creature, the next attack played this turn deals 10 less damage. \r\nA Danian Creature, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/y0Rk6NI.png",
    "uniqueId": "Grantkae's Stance__fun"
  },
  {
    "id": "50/100",
    "name": "Gravel Grind",
    "set": "fun",
    "rarity": "rare",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": ":earth:Earth: When Gravel Grind deals damage, remove a card in a general discard pile from the game.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/2d9D88i.png",
    "uniqueId": "Gravel Grind__fun"
  },
  {
    "id": "51/100",
    "name": "Heartsync",
    "set": "fun",
    "rarity": "rare",
    "bp": 3,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 75: Look at the top two cards of your opponent's Attack Deck. Put one on top of that deck and the other on the bottom.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/Dc5dztT.png",
    "uniqueId": "Heartsync__fun"
  },
  {
    "id": "52/100",
    "name": "Inner Flood",
    "set": "fun",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 0,
    "ability": ":water:Water: Remove a Mugic counter from a Creature, if you do put a Mugic counter on another Creature controlled by the same player. (You must choose a Creature that can have Mugic counters put on it.)",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/eEoTdfq.png",
    "uniqueId": "Inner Flood__fun"
  },
  {
    "id": "53/100",
    "name": "Instantaneous Inspiration",
    "set": "fun",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 60: Deal 10 damage.\r\nStat Check :speed:Speed 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/Z9romJX.png",
    "uniqueId": "Instantaneous Inspiration__fun"
  },
  {
    "id": "54/100",
    "name": "Interthink",
    "set": "fun",
    "rarity": "rare",
    "bp": 3,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 75: You can put a :genericmugic:Mugic counter on any Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Sanford Greene, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/DHIozwG.png",
    "uniqueId": "Interthink__fun"
  },
  {
    "id": "55/100",
    "name": "Massblink",
    "set": "fun",
    "rarity": "rare",
    "bp": 3,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 75: You can swap the spaces on the Battleboard of two unengaged Creatures that are adjacent to each other.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Jimmy Tran",
    "imageUrl": "https://i.imgur.com/fge56vv.png",
    "uniqueId": "Massblink__fun"
  },
  {
    "id": "56/100",
    "name": "Powercut",
    "set": "fun",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 60: Deal 10 damage.\r\nLose 60 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/4yYDPce.png",
    "uniqueId": "Powercut__fun"
  },
  {
    "id": "57/100",
    "name": "Sirocco",
    "set": "fun",
    "rarity": "rare",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Flip a face-down Battlegear you control face-up.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/tfrLVhk.png",
    "uniqueId": "Sirocco__fun"
  },
  {
    "id": "58/100",
    "name": "Smartsmack",
    "set": "fun",
    "rarity": "uncommon",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 60: Deal 10 damage.\r\nStat Check :wisdom:Wisdom 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/QhY1L8Q.png",
    "uniqueId": "Smartsmack__fun"
  },
  {
    "id": "59/100",
    "name": "Strengthening Bond",
    "set": "fun",
    "rarity": "rare",
    "bp": 3,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 75: When Strengthening Bond deals damage, destroy target Battlegear.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/JOf5tbR.png",
    "uniqueId": "Strengthening Bond__fun"
  },
  {
    "id": "60/100",
    "name": "Thermo Rings",
    "set": "fun",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Check :wisdom:Wisdom 50: Deal 5 Damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/uz5UeZ1.png",
    "uniqueId": "Thermo Rings__fun"
  },
  {
    "id": "61/100",
    "name": "Thinkray",
    "set": "fun",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 60: Deal 10 damage.\r\nLose 60 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/QwzWfE6.png",
    "uniqueId": "Thinkray__fun"
  },
  {
    "id": "62/100",
    "name": "Unbalanced Charge",
    "set": "fun",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 60: Deal 10 damage.\r\nLose 60 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/Trx8AOT.png",
    "uniqueId": "Unbalanced Charge__fun"
  },
  {
    "id": "63/100",
    "name": "Unified Tribecharge",
    "set": "fun",
    "rarity": "ultra rare",
    "bp": 5,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 10 damage for each Tribe you control.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Reggie Butler",
    "imageUrl": "https://i.imgur.com/XNtqlZp.png",
    "uniqueId": "Unified Tribecharge__fun"
  },
  {
    "id": "64/100",
    "name": "Valor Continuum",
    "set": "fun",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 60: Deal 10 damage.\r\nLose 60 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/gRIJaem.png",
    "uniqueId": "Valor Continuum__fun"
  },
  {
    "id": "74/200",
    "name": "Aerosion",
    "set": "au",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": 5,
    "water": null,
    "ability": ":air:Air: Flip engaged Creature's Battlegear face-down.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/TXLqPNa.png",
    "uniqueId": "Aerosion__au"
  },
  {
    "id": "75/200",
    "name": "Airize",
    "set": "au",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature has :air:Air, damage dealt by Airize is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Keith Conroy, Reggie Butler",
    "imageUrl": "https://i.imgur.com/mdFWHjs.png",
    "uniqueId": "Airize__au"
  },
  {
    "id": "76/200",
    "name": "Airsault",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": 15,
    "earth": null,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/oP1Fd5w.png",
    "uniqueId": "Airsault__au"
  },
  {
    "id": "77/200",
    "name": "Atmosfear",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has Invisibility, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/dSSA5wD.png",
    "uniqueId": "Atmosfear__au"
  },
  {
    "id": "78/200",
    "name": "Before the Storm",
    "set": "au",
    "rarity": "super rare",
    "bp": 4,
    "base": 15,
    "fire": null,
    "air": 15,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Before the Storm counts as your first attack this combat. (This does not count as your first attack while on the burst.)",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/cmZ6pGk.png",
    "uniqueId": "Before the Storm__au"
  },
  {
    "id": "79/200",
    "name": "Clean Slide",
    "set": "au",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If the opposing engaged Creature has :earth:Earth, damage dealt by Clean Slide is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/DNpq1aj.png",
    "uniqueId": "Clean Slide__au"
  },
  {
    "id": "80/200",
    "name": "Combustion Carnage",
    "set": "au",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": 0,
    "air": null,
    "earth": null,
    "water": null,
    "ability": ":fire:Fire: You can sacrifice an unengaged Creature you control. If you do, deal 20 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/oALH1xe.png",
    "uniqueId": "Combustion Carnage__au"
  },
  {
    "id": "81/200",
    "name": "Consuming Flame",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": 15,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/EEVcSss.png",
    "uniqueId": "Consuming Flame__au"
  },
  {
    "id": "82/200",
    "name": "Deadwater Devastation",
    "set": "au",
    "rarity": "super rare",
    "bp": 4,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 15,
    "ability": ":water:Water: Remove all Mugic counters from a Creature of your choice.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, Reggie Butler",
    "imageUrl": "https://i.imgur.com/EQnS4Me.png",
    "uniqueId": "Deadwater Devastation__au"
  },
  {
    "id": "83/200",
    "name": "Dry Touch",
    "set": "au",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": null,
    "ability": ":fire:Fire: The opposing engaged Creature loses :water:Water.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/3HmAwVp.png",
    "uniqueId": "Dry Touch__au"
  },
  {
    "id": "84/200",
    "name": "Dust Strike",
    "set": "au",
    "rarity": "common",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "Stat Check :speed:Speed 60: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/jzCOvDm.png",
    "uniqueId": "Dust Strike__au"
  },
  {
    "id": "85/200",
    "name": "Earth Pulse",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": 15,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Reggie Butler",
    "imageUrl": "https://i.imgur.com/v16DaxM.png",
    "uniqueId": "Earth Pulse__au"
  },
  {
    "id": "86/200",
    "name": "Earthshape",
    "set": "au",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "gain :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "artist": "Reggie Butler, Andrew Bradshaw",
    "imageUrl": "https://i.imgur.com/JgUvzKq.png",
    "uniqueId": "Earthshape__au"
  },
  {
    "id": "87/200",
    "name": "Eidolon Advance",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If your engaged Creature has a Mugic counter, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Keith Conroy, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/ioaJfgQ.png",
    "uniqueId": "Eidolon Advance__au"
  },
  {
    "id": "88/200",
    "name": "Eroding Blast",
    "set": "au",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": 10,
    "earth": null,
    "water": null,
    "ability": ":air:Air: The opposing engaged Creature loses :earth:Earth.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/URk7vn5.png",
    "uniqueId": "Eroding Blast__au"
  },
  {
    "id": "89/200",
    "name": "Essential Evaporation",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": 5,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Adrian Barrios, Reggie Butler",
    "imageUrl": "https://i.imgur.com/Wh2aZ7Z.png",
    "uniqueId": "Essential Evaporation__au"
  },
  {
    "id": "90/200",
    "name": "Extinguishing Fountain",
    "set": "au",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": ":water:Water: The opposing engaged Creature loses :fire:Fire.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/SjoSj22.png",
    "uniqueId": "Extinguishing Fountain__au"
  },
  {
    "id": "91/200",
    "name": "Fireram",
    "set": "au",
    "rarity": "common",
    "bp": 3,
    "base": 10,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/TlDsA81.png",
    "uniqueId": "Fireram__au"
  },
  {
    "id": "92/200",
    "name": "Flame Breach",
    "set": "au",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "gain :fire:Fire ",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/E6AvRUQ.png",
    "uniqueId": "Flame Breach__au"
  },
  {
    "id": "93/200",
    "name": "Flame Fright",
    "set": "au",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": 15,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Remove a :genericmugic:Mugic counter from engaged Creatures with less than 50 :wisdom:Wisdom or :courage:Courage ",
    "flavorText": "",
    "unique": false,
    "artist": "Stone Perales",
    "imageUrl": "https://i.imgur.com/BqT8hME.png",
    "uniqueId": "Flame Fright__au"
  },
  {
    "id": "94/200",
    "name": "Flood Force",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 15,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/iv0E5LY.png",
    "uniqueId": "Flood Force__au"
  },
  {
    "id": "95/200",
    "name": "Fluid Flame",
    "set": "au",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "gain :water:Water ",
    "flavorText": "",
    "unique": false,
    "artist": "Keith Conroy, Reggie Butler",
    "imageUrl": "https://i.imgur.com/FT5dEhY.png",
    "uniqueId": "Fluid Flame__au"
  },
  {
    "id": "96/200",
    "name": "Gladiator's Fire",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature has Recklessness, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/oyimh0t.png",
    "uniqueId": "Gladiator's Fire__au"
  },
  {
    "id": "97/200",
    "name": "Grounding Grapple",
    "set": "au",
    "rarity": "super rare",
    "bp": 4,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": 15,
    "water": null,
    "ability": ":earth:Earth: Look at the top three cards of your Location Deck and put them back in any order. You can reveal a new active Location.",
    "flavorText": "",
    "unique": false,
    "artist": "Emilio Lopez, Keith Conroy",
    "imageUrl": "https://i.imgur.com/UUW6VsP.png",
    "uniqueId": "Grounding Grapple__au"
  },
  {
    "id": "98/200",
    "name": "Incessant Wave",
    "set": "au",
    "rarity": "common",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "Stat Check :courage:Courage 60: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/iXb6ySk.png",
    "uniqueId": "Incessant Wave__au"
  },
  {
    "id": "99/200",
    "name": "Inferno Claws",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "David Rodriguez, Emilio Lopez",
    "imageUrl": "https://i.imgur.com/tR9z2Xv.png",
    "uniqueId": "Inferno Claws__au"
  },
  {
    "id": "100/200",
    "name": "Magma Might",
    "set": "au",
    "rarity": "super rare",
    "bp": 4,
    "base": 15,
    "fire": 15,
    "air": null,
    "earth": null,
    "water": null,
    "ability": ":fire:Fire: Destroy all Battlegear equipped to the opposing engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/UdFUO6j.png",
    "uniqueId": "Magma Might__au"
  },
  {
    "id": "101/200",
    "name": "Meditative Leap",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 100: Remove a :genericmugic:Mugic counter from a Creature you control. If you do, put a :genericmugic:Mugic counter on your engaged Creature.\r\nStat Check :speed:Speed 100: Draw an Attack Card and discard an Attack Card.",
    "flavorText": "",
    "unique": false,
    "artist": "Keith Conroy, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/gr8B7Y7.png",
    "uniqueId": "Meditative Leap__au"
  },
  {
    "id": "102/200",
    "name": "Mind Mash",
    "set": "au",
    "rarity": "super rare",
    "bp": 5,
    "base": 15,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Challenge :wisdom:Wisdom vs :courage:Courage 5: Deal 15 damage.\r\nChallenge :wisdom:Wisdom vs :power:Power 5: Deal 15 damage.\r\nChallenge :wisdom:Wisdom vs :speed:Speed 5: Deal 15 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Reggie Butler, Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/IZ3tkte.png",
    "uniqueId": "Mind Mash__au"
  },
  {
    "id": "103/200",
    "name": "Mindvoid",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :courage:Courage 100: Gain 5 Energy.\r\nStat Check :wisdom:Wisdom 100: Remove a :genericmugic:Mugic counter from a Creature you control. If you do, put a :genericmugic:Mugic counter on your engaged Creature.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Reggie Butler",
    "imageUrl": "https://i.imgur.com/elAyk4H.png",
    "uniqueId": "Mindvoid__au"
  },
  {
    "id": "104/200",
    "name": "Mineral Mayhem",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "You can choose to have Mineral Mayhem deal 0 damage. If you do, gain 100 :courage:Courage.",
    "flavorText": "",
    "unique": false,
    "artist": "Keith Conroy, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/yr1ADnu.png",
    "uniqueId": "Mineral Mayhem__au"
  },
  {
    "id": "105/200",
    "name": "Obscuring Winds",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "You can choose to have Obscuring Winds deal 0 damage. If you do, gain 100 :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/VdqKfMo.png",
    "uniqueId": "Obscuring Winds__au"
  },
  {
    "id": "106/200",
    "name": "Outfreeze",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "You can choose to have Outfreeze deal 0 damage. If you do, gain 100 :wisdom:Wisdom.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/2FrLpnN.png",
    "uniqueId": "Outfreeze__au"
  },
  {
    "id": "107/200",
    "name": "Paraseed",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": null,
    "ability": "If Hive is active, deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/7uxpvbI.png",
    "uniqueId": "Paraseed__au"
  },
  {
    "id": "108/200",
    "name": "Primordial Rage",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 5,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "You can choose to have Primordial Rage deal 0 damage. If you do, gain 100 :power:Power.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/1uT36Ur.png",
    "uniqueId": "Primordial Rage__au"
  },
  {
    "id": "109/200",
    "name": "Rainspears",
    "set": "au",
    "rarity": "common",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 10,
    "ability": "Stat Check :wisdom:Wisdom 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/5ufZ4QK.png",
    "uniqueId": "Rainspears__au"
  },
  {
    "id": "110/200",
    "name": "Retaliatory Strike",
    "set": "au",
    "rarity": "super rare",
    "bp": 3,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Retaliatory Strike deals additional damage equal to the damage dealt by the last attack played this combat.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/PXi6GyM.png",
    "uniqueId": "Retaliatory Strike__au"
  },
  {
    "id": "111/200",
    "name": "Sleet Slide",
    "set": "au",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": 5,
    "ability": "If the opposing engaged Creature has :water:Water, damage dealt by Sleet Slide is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/Iq026cr.png",
    "uniqueId": "Sleet Slide__au"
  },
  {
    "id": "112/200",
    "name": "Smokesurge",
    "set": "au",
    "rarity": "common",
    "bp": 0,
    "base": 0,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature has :fire:Fire, damage dealt by Smokesurge is reduced to 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/TTHirNk.png",
    "uniqueId": "Smokesurge__au"
  },
  {
    "id": "113/200",
    "name": "Sudden Flare",
    "set": "au",
    "rarity": "common",
    "bp": 2,
    "base": 10,
    "fire": 5,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :wisdom:Wisdom 60: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/Educ9O5.png",
    "uniqueId": "Sudden Flare__au"
  },
  {
    "id": "114/200",
    "name": "Synaptic Acceleration",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 100: Deal 5 damage.\r\nStat Check :speed:Speed 100: Draw an Attack Card and discard an Attack Card.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/XQZ4jmI.png",
    "uniqueId": "Synaptic Acceleration__au"
  },
  {
    "id": "115/200",
    "name": "Tectostrike",
    "set": "au",
    "rarity": "common",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": 10,
    "water": null,
    "ability": "Stat Check :courage:Courage 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/s81lzYO.png",
    "uniqueId": "Tectostrike__au"
  },
  {
    "id": "116/200",
    "name": "Terrantula Tackle",
    "set": "au",
    "rarity": "rare",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": 15,
    "water": null,
    "ability": "Destroy all Battlegear equipped to engaged Creatures with less than 50 :power:Power or :speed:Speed.",
    "flavorText": "",
    "unique": false,
    "artist": "Khary Randolph, Reggie Butler",
    "imageUrl": "https://i.imgur.com/tW8nevb.png",
    "uniqueId": "Terrantula Tackle__au"
  },
  {
    "id": "117/200",
    "name": "Traditionalist's Charge",
    "set": "au",
    "rarity": "common",
    "bp": 1,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 100: Deal 5 damage.\r\nStat Check :courage:Courage 100: Gain 5 Energy.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Reggie Butler",
    "imageUrl": "https://i.imgur.com/HLXAWQi.png",
    "uniqueId": "Traditionalist's Charge__au"
  },
  {
    "id": "118/200",
    "name": "Turbulence Funnel",
    "set": "au",
    "rarity": "common",
    "bp": 3,
    "base": 10,
    "fire": null,
    "air": 10,
    "earth": null,
    "water": null,
    "ability": "Stat Check :speed:Speed 60: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/kpu8LVB.png",
    "uniqueId": "Turbulence Funnel__au"
  },
  {
    "id": "119/200",
    "name": "Vacuum Hemisphere",
    "set": "au",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 10,
    "water": null,
    "ability": ":earth:Earth: The opposing engaged Creature loses :air:Air.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent",
    "imageUrl": "https://i.imgur.com/xclPX4h.png",
    "uniqueId": "Vacuum Hemisphere__au"
  },
  {
    "id": "120/200",
    "name": "Vapor Wipeout",
    "set": "au",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "gain :air:Air.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/VGm42UZ.png",
    "uniqueId": "Vapor Wipeout__au"
  },
  {
    "id": "121/200",
    "name": "Voltorch",
    "set": "au",
    "rarity": "common",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": "Stat Check :power:Power 60: Deal 5 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/8KbKZUV.png",
    "uniqueId": "Voltorch__au"
  },
  {
    "id": "122/200",
    "name": "Wall of Flame",
    "set": "au",
    "rarity": "rare",
    "bp": 3,
    "base": 0,
    "fire": 5,
    "air": 5,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Flip one Battlegear face-up and one Battlegear face-down.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/uHYVesn.png",
    "uniqueId": "Wall of Flame__au"
  },
  {
    "id": "123/200",
    "name": "Xenocentric Wrath",
    "set": "au",
    "rarity": "rare",
    "bp": 2,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If your engaged Creature does not share a Tribe with the opposing engaged Creature, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/78Tc9Ft.png",
    "uniqueId": "Xenocentric Wrath__au"
  },
  {
    "id": "14/100",
    "name": "Emberwhip",
    "set": "fas",
    "rarity": "common",
    "bp": 2,
    "base": 5,
    "fire": 10,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If the opposing engaged Creature has :water:Water, deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Bob Rivard",
    "imageUrl": "https://i.imgur.com/G8UKbVm.png",
    "uniqueId": "Emberwhip__fas"
  },
  {
    "id": "FAS-b9hw3oms",
    "name": "Faster than the Wind",
    "set": "fas",
    "rarity": "rare",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": 15,
    "earth": null,
    "water": null,
    "ability": "Gain 100 :speed:Speed. lose :courage:Courage, :power:Power, and:wisdom:Wisdom so those Disciplines equal 0.",
    "flavorText": "",
    "unique": false,
    "artist": "Etienne St. Laurent, Bob Rivard",
    "imageUrl": "https://i.imgur.com/P9pvmn4.png",
    "uniqueId": "Faster than the Wind__fas"
  },
  {
    "id": "P-022",
    "name": "Flurry of Fists",
    "set": "op",
    "rarity": "promo",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 5 damage for each Attack Card in your Attack Discard pile. If you have 7 or more Attack Cards in your Attack Discard pile, deal 0 damage instead.",
    "flavorText": "",
    "unique": false,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/6pqXjrk.png",
    "uniqueId": "Flurry of Fists__op"
  },
  {
    "id": "OP-l97or0d3",
    "name": "M.A.C.A., (Melee Artists Collaborative Attack)",
    "set": "op",
    "rarity": "common",
    "bp": 2,
    "base": 0,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "Deal 5 damage for each Mipedian Creature you control.",
    "flavorText": "",
    "unique": true,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/skyFIFD.png",
    "uniqueId": "M.A.C.A., (Melee Artists Collaborative Attack)__op"
  },
  {
    "id": "OP1-11/20",
    "name": "Allmageddon",
    "set": "op",
    "rarity": "super rare",
    "bp": 5,
    "base": 10,
    "fire": 10,
    "air": 10,
    "earth": 10,
    "water": 10,
    "ability": "",
    "flavorText": "",
    "unique": true,
    "artist": "Imaginary Friends Studios",
    "imageUrl": "https://i.imgur.com/qrvgJ5c.png",
    "uniqueId": "Allmageddon__op"
  },
  {
    "id": "OP1-12/20",
    "name": "Catacollision",
    "set": "op",
    "rarity": "uncommon",
    "bp": 3,
    "base": 5,
    "fire": 5,
    "air": 5,
    "earth": 5,
    "water": 5,
    "ability": "",
    "flavorText": "",
    "unique": false,
    "artist": "Andrew Bradshaw, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/XkApDS8.png",
    "uniqueId": "Catacollision__op"
  },
  {
    "id": "OP1-13/20",
    "name": "Frightening Muck",
    "set": "op",
    "rarity": "common",
    "bp": 2,
    "base": 5,
    "fire": null,
    "air": null,
    "earth": 5,
    "water": 5,
    "ability": "Challenge :courage:Courage 15: Deal 10 damage.",
    "flavorText": "",
    "unique": false,
    "artist": "Patrick Boutin Gagne, Etienne St.Laurent, Edwin Nebres",
    "imageUrl": "https://i.imgur.com/4KkM5ft.png",
    "uniqueId": "Frightening Muck__op"
  },
  {
    "id": "P-014",
    "name": "Carniwin",
    "set": "fun",
    "rarity": "promo",
    "bp": 1,
    "base": 10,
    "fire": null,
    "air": null,
    "earth": null,
    "water": null,
    "ability": "If there are an odd number of Creatures in play, deal 10 damage.\r\nIf there are an even number of Creatures in play, your engaged Creature loses 10 Energy.",
    "flavorText": "",
    "unique": false,
    "artist": "HotShots VFX",
    "imageUrl": "https://i.imgur.com/PpIvdOV.png",
    "uniqueId": "Carniwin__fun"
  },
  {
    "id": "DOP-fn6iy6c1",
    "name": "Nexdoors",
    "set": "dop",
    "rarity": "rare",
    "bp": 0,
    "base": 0,
    "fire": null,
    "air": 0,
    "earth": null,
    "water": null,
    "ability": ":air:Air: Look at the top two cards of your Attack Deck. Put one of them on the top of that deck and the other on the bottom.",
    "flavorText": "",
    "unique": false,
    "artist": "Etienne St.Laurent, Aris Iliopoulos",
    "imageUrl": "https://i.imgur.com/LBjhWtH.png",
    "uniqueId": "Nexdoors__dop"
  }
];

// Helper functions to work with the database
export const getAttackById = (idOrKey) => {
  // First try direct ID lookup for backward compatibility
  const directMatch = attackDatabase.find(attack => attack.id === idOrKey);
  if (directMatch) return directMatch;
  
  // Next try uniqueId match
  const uniqueMatch = attackDatabase.find(attack => attack.uniqueId === idOrKey);
  if (uniqueMatch) return uniqueMatch;
  
  // If not found, check if it's a composite key
  if (idOrKey.includes('__')) {
    const [name, set] = idOrKey.split('__');
    return attackDatabase.find(attack => 
      attack.name === name && attack.set === set
    );
  }
  
  return null;
};

export const getAllAttackNames = () => {
  return attackDatabase.map(attack => ({
    id: attack.uniqueId || createUniqueCardKey(attack), // Use the composite key here
    name: attack.name,
    set: attack.set || '',
    setDisplay: attack.set ? attack.set.toUpperCase() : '',
    fire: attack.fire !== undefined ? attack.fire : null,
    air: attack.air !== undefined ? attack.air : null,
    earth: attack.earth !== undefined ? attack.earth : null,
    water: attack.water !== undefined ? attack.water : null,
    bp: attack.bp || 0,
    // Keep the original ID for reference
    originalId: attack.id
  }));
};
